import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const MainContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 3.125rem 0;
    flex-direction: column;
    border-radius: 1.625rem;
    justify-content: center;

    .ContainerTable {
        opacity: 1;
        background-color: rgba(255, 255, 255, 0.9);
    }

    &:has(.receituario) {
        background-size: cover;
        background-color: #292E38;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('https://agroreceita.com.br/wp-content/uploads/2020/09/si%CC%81mbolo-branco-1.webp');
    }
`;

export const Title = styled.h2`
    color: #ffff;
    font-size: 2rem;
    font-weight: 900;
    text-align: center;
    margin-bottom: 0.5rem;

    ${({ className }) =>
        className === 'plans' &&
        `
        color: ${theme.colors.gray.Cinza_2};
    `}

    @media (max-width: 570px) {
        font-size: 1.5rem;
    }
`;

export const Subtitle = styled.p`
    margin-bottom: 2rem;
    padding: 1rem;
    
    color: #dfe4eb;
    font-size: 1.1rem;
    text-align: center;

    ${({ className }) =>
        className === 'plans' &&
        `
        color: #303848;
    `}

    @media (max-width: 570px) {
        font-size: 1rem;
    }
`;


export const ContainerTable = styled.div`
    width: 100%;
    margin: auto;
    max-width: ${({ isPrepaid }) => (isPrepaid ? '35rem' : '960px')} !important;

    display: flex;
    flex-direction: column;

    border-radius: 1rem;
    background-color: #fff;

    @media (max-width: 1237px) {
        /* border-radius: 0; */

        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

export const Table = styled.div`
    width: 100%;
    font-size: 1rem;
    border-collapse: collapse;
    font-family: 'lato', sans-serif;
    table-layout: unset; // Garante que as larguras das colunas sejam fixas

    /* border-top-left-radius:1rem ; */

    @media (max-width: 767px) {
        table-layout: fixed;
    }

    @media (max-width: 470px) {
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 570px) {
        font-size: 1rem;
        table-layout: fixed;
    }
`;

export const TableHead = styled.div`
    background-color: #FFFFFF;

    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;

    & div:nth-child(1) {
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        background-color: #fFFFFF !important;
    }

    @media (max-width: 470px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0.5rem 0;
    }
`;

export const TableBody = styled.div`
    position: relative;
`;

export const TableRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${({ isPrepaid }) => (isPrepaid ? "space-between" : "space-evenly")};

    &:nth-child(odd) {
        background-color: #f9f9f9;
    }

    @media (max-width: 570px) {
        width: 100%;

        font-size: 0.9rem;
        padding: 0.313rem;
    }

 
`;

export const TableHeader = styled.div`
    width: 100%;
    max-width: 200px;

    padding: 1.875rem;
    color: ${theme.colors.gray.Cinza_2};
    font-weight: 900;
    font-size: 1.25rem;
    text-align: center;

    .icon {
        display: flex;
        justify-content: start;

        width: 30px;
        height: auto;
    }

    :first-child {
        width: 100%;
        max-width: 350px;
        /* border-top-left-radius: 1rem; */
    }

    :last-child {
        /* border-top-right-radius: 1rem; */
    }

    @media (max-width: 926px) {
        width: 100%;
        max-width: 180px;

        :first-child {
            width: 100%;
            max-width: 350px;
            border-top-left-radius: 1rem;
        }
    }

    @media (max-width: 767px) {
        max-width: 120px;

        font-size: 0.875rem;
        padding: 0.5rem;
    }

    @media (max-width: 470px) {
        /* flex: 1; // Divide o espaço igualmente entre os cabeçalhos */
        max-width: 105px;
        padding: 0.5rem;
        font-size: 0.875rem;

        :first-child {
            width: 100%; 
            max-width: ${({ isPrepaid }) => (isPrepaid ? '150px' : "120px")};
        }

        &:nth-child(2) {
            max-width: ${({ isPrepaid }) => (isPrepaid ? '150px' : "89px")};
            /* padding-left: ${({ isPrepaid }) => (isPrepaid ? '65vw' : '36vw')}; */
            /* padding-right: 0; */
        }

        &:nth-child(3) {
            max-width: 79px;
            padding-right: 0;
        }

        &:nth-child(4) {
            max-width: 70px;
            padding-right: 0;
        }
    }
`;

export const TableCell = styled.div`
    padding: 0.6rem;
    color: ${theme.colors.gray.Cinza_2};
    font-size: 0.75rem;
    text-align: center;

    &:first-child {
        width: 100%;
        max-width: 350px;

        text-align: left;
        font-weight: 700;
        padding-left: 2rem;
        font-size: 0.938rem;
        /* width: ${({ isPrepaid }) => (isPrepaid ? '69%' : '22%')}; // Define 60% da largura da tabela para descrição */
        /* min-width: 128px; // Largura mínima para evitar quebra */
        height: auto;
    }

    &:nth-child(2),
    &:nth-child(3),
    &:last-child {
        /* width: ${({ isPrepaid }) => (isPrepaid ? '31%' : '13.3%')};  // Cada coluna de check ocupa ~13.3% (totalizando ~40%) */
        
        width: 100%;
        max-width: 200px;
        /* max-width: 85px; // Largura máxima para ícones */

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 0.875rem;
        font-weight: 400;

        >img{
            width: 30px;
            height: 30px;
        }

        @media (max-width: 926px) {
            max-width: 180px;
        }

        @media (max-width: 767px) {
            max-width: 120px;

            >img{
                width: 25px;
                height: 25px;
            }
        }
    }

    &.price-prepaid {
        width: 100%;
        max-width: 255px;
    }

    img {
        width: ${({ isPrepaid }) => (isPrepaid ? '16%' : '')}; 
        }

    @media (max-width: 767px) {
        padding: 0.5rem;
        font-size: 12px;
        font-weight: 800;

        &:first-child {
            padding-left: 0.4rem;
            font-size: 12px;

            height: auto;
            /* max-width: 100px; // Mantém o mínimo de 45% em telas menores */
            /* width: 100%; // Mantém a largura fixa como 45% em telas menores */
        }

        &:nth-child(2), 
        &:nth-child(3), 
        &:last-child {
            font-size: 12px;
            font-weight: 400;

            /* >img{
                width: 20px;
                height: 20px;
            } */
        }

        &.support-row {
            min-width: 100px;

            flex-direction: column;
            justify-content: flex-start;
        }

        /* img {
            width: 48%;
        } */

    @media (max-width: 470px) {
        &:first-child {
            width: 100%;
            max-width: ${({ isPrepaid }) => (isPrepaid ? "100%" : "105px")};
            height: auto;
            padding: 0 0.5rem;

            display: flex;
            align-items: center;
        }

        &:nth-child(2){
            max-width: 89px;
            height: 65px;
            padding-right: 0;
        }
        &:nth-child(3){
            max-width: 79px;
            height: 65px;
            padding-right: 0;
        }

        &:last-child {
            max-width: ${({ isPrepaid }) => (isPrepaid ? '120px' : "70px")};
            height: 65px;
            padding-right: 0;
        }

        &.price-prepaid {
            width: 100%;
            height: auto;
            max-width: 255px;
        }

        /* img { 
            width: ${({ isPrepaid }) => (isPrepaid ? '48%' : '48%')};
        } */
    }
}
`;

export const ContainerCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    >p:first-child{
        font-size: 15px;
    }

    >p{
        font-size: 12px;
    }

    @media (max-width: 767px) {
       >p:first-child{
            font-size: ${({ isPrepaid }) => (isPrepaid ? '15px' : '12px')};
            line-height: 1rem;
        }

        >p{
            font-size: ${({ isPrepaid }) => (isPrepaid ? '12px' : '9px')};
            line-height:  ${({ isPrepaid }) => (isPrepaid ? 'auto' : '1rem')};
        }
    }
`

export const SupportRow = styled.div`
    width: 100%;

    display: flex;
    justify-items: center !important;
    justify-content: ${({ isPrepaid }) =>
        isPrepaid ? "space-evenly" : "normal"};

    background-color: white;

    >div{
        width: 100%;
        height: auto !important;

        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    @media (max-width: 479px) {
        justify-content: ${({ isPrepaid }) => (isPrepaid ? "space-between" : "normal")};
    }
    
    
  ${({ isPrepaid }) =>
        !isPrepaid &&
        `
    @media (max-width: 767px) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      width: 97vw;
      gap: 0.2rem;
      flex-direction: row;
      justify-content: space-between;
      align-content: center
      

      >div:first-child {
        display: none;
      }

      td {
        width: 100%;
        padding: 0.5rem 0;
      }
    }
  `}
`;

export const SupportTitle = styled.h4`
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;

  @media (max-width: 767px) {
    display: ${({ isPrepaid }) => (isPrepaid ? 'block' : 'block')};
  }
`;

export const SupportPlanName = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: ${({ isPrepaid }) => (isPrepaid ? 'none' : 'block')};
    width: 100%;
    font-weight: bold;
    text-align: center;
    margin-bottom: 0.313rem;
    padding: 0.5rem 0;
  }
`;

export const SupportList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;

  @media (max-width: 767px) {
    width: 100%;
    font-size: 0.625rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.2rem;
    font-weight: 400;
  }
`;

export const SupportItem = styled.li`
  color: #666;
  font-size: 0.9rem;

  @media (max-width: 767px) {
    width: 100%;
    font-size: 0.625rem;
    text-align: center;
  }
`;

export const DeskContainerButtonPrePago = styled.div`
  width: 100%;
  height: auto;

  display: flex;

  >div{
    width: 100%;
  }

  @media (max-width: 1237px) {
    display: none;
  }
`;

export const MobileContainerButtonPrePago = styled.div`
  width: 100%;
  height: auto;
  
  display: none;

  >div{
    width: 100%;
    max-width: 960px;
    margin: 0 1.25rem;
  }

  @media (max-width: 1237px) {
    display: flex;
    justify-content: center;
  }
`;

export const PriceRow = styled.div`
    display: flex;
    align-items: center;

    div:first-child {
       height: ${({ isRA2025 }) => (isRA2025 ? 'auto' : "100% !important")};
       padding-right: 0;
      
       
       margin-bottom: 0;

       >button{
        padding: ${({ isRA2025 }) => (isRA2025 ? '8px' : "")};
       }
    }

    &.pre-paid-price {
        @media (width > 1237px) {
            display: flex;
            /* position: absolute; */
            /* left: -22px;  */

            align-items: center;

            td {
                p {
                    width: 210px;
                }

                div:first-child {
                    padding-left: 1rem;
                    width: 146%
                }
            }
    }

    @media (max-width: 1237px) {
       td:first-child {
        display: none;
       }
    }
}

    @media (max-width: 1237px) {
        display: ${({ isPrepaid }) => (isPrepaid ? 'flex' : 'none')};
        flex-direction: ${({ isPrepaid }) => (isPrepaid ? 'column' : '')};
        align-items: ${({ isPrepaid }) => (isPrepaid ? 'center' : '')};
    }
`;

export const PriceWithButtonContainer = styled.div`
    width: 100%;
    display: flex;
    padding: 0.625rem;
    
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 1237px) {
        width: ${({ isPrepaid }) => (isPrepaid ? '154%' : '100%')};
        padding: 0.625rem;
        max-width: 1000px;
    }

    @media (max-width: 570px) {
        width: ${({ isPrepaid }) => (isPrepaid ? '104%' : '100%')};
        padding: 0.5rem;
        max-width: 1000px;

        .price-prepaid {
            width: 100%;
            max-width: 1000px !important;
        }
    }

    @media (max-width: 320px) {
        padding: 0.313rem;
    }
`;


export const MobilePriceContainer = styled.div`
    display: none;

    @media (max-width: 1237px) {
        padding: 0;
        width: 100%;
        max-width: 960px;
        
        display: flex;
        
        flex-direction: row;
        justify-content: space-between;
        background-color: #f9f9f9;
    }
`;

export const MobilePriceBox = styled.div`
    display: flex;
    width: 100%;
    height: 9.875rem;
    max-width: 100%;
    padding: 1.5rem 0.5rem 1rem;
    
    text-align: center;
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
    background-color: ${props => (props.positionMiddle ? "#292E38" : "#303848")};

    @media (max-width: 570px) {
        height: 12.5rem;
    }
`;

export const MobilePriceBoxTitle = styled.h4`
    color: white;
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 0.625rem;

    @media (max-width: 1237px) {
        font-size: 1rem;
    }
`;

// Para black
export const OldPrice = styled.div`
    color: ${({ isMobile }) => (isMobile ? '#BAC1CF' : '#21262F')};
    text-decoration: line-through;
    font-weight: 700;
    font-size: ${({ isMobile }) => (isMobile ? '13px' : '1rem')};

    margin-bottom: 1rem;

    @media (max-width: 1237px) {
        margin-bottom: 0;

        >span{
            text-decoration: line-through;

            color: #dfe4eb;
            color: ${({prePago}) => (prePago ? '#21262F' : '#dfe4eb')};
        }
    }
    
    @media (max-width: 926px) {
        margin-bottom: 0;
        margin-top: 1rem;
    }
`;

export const NewPrice = styled.div`
    font-size: ${({ isMobile, prePago }) => (prePago ? "2.5rem" : isMobile ? '1.2rem' : '1.75rem')};
    font-weight: 800;
    color: ${({ isMobile, promo, prePago }) => (prePago ? `${theme.colors.red.Vermelho_erro}` : isMobile ? '#DFE4EB' : promo ? `${theme.colors.red.Vermelho_erro}` : '#21262F')};
    /* color: ${({ isMobile }) => (isMobile ? '#DFE4EB' : `${theme.colors.red.Vermelho_erro}`)}; */
    /* margin-bottom: 4px; */

    @media (max-width: 926px) {
        margin-top: 0;
        margin-bottom: 1rem;
    }

    @media (max-width: 386px) {
        font-size: ${({ isMobile, prePago }) => (prePago ? "#2.5rem" : isMobile ? '1.2rem' : '1.75rem')};
    }
    .currency-symbol {
         font-size: 1.2rem;
         vertical-align: baseline;

         @media (max-width: 479px) {
            font-size: 0.8rem;
         }
     }

    .cents {
        font-size: 1.2rem;
        vertical-align: baseline;
    }
`;

// Descomentar pós Black
export const Price = styled.div`
    color: ${theme.colors.gray.Cinza_2};
    font-weight: 900;
    font-size: 2rem;
    color: ${({ isMobile, promo }) => ( promo ? `${theme.colors.red.Vermelho_erro}` : isMobile ? '#DFE4EB' : '#21262F')};
    /* color: ${props => (props.isMobile ? "#DFE4EB" : "#21262F")}; */
    /* color: ${theme.colors.red.Vermelho_erro}; */

    .currency-symbol {
        font-size: 1.2rem;
        vertical-align: baseline;
    }

    .cents {
        font-size: 1.2rem;
        vertical-align: baseline;
    }

    @media (max-width: 1237px) {
        padding: 0 0 0.438rem;
        /* font-size: ${({ isPrepaid }) => (isPrepaid ? '2rem' : '1rem')}; */
    }

    @media (max-width: 769px) {
    .currency-symbol {
        font-size: 0.8rem;
        vertical-align: baseline;
    }

    .cents {
        font-size: 0.8rem;
        vertical-align: baseline;
    }

        font-size: ${({ isPrepaid }) => (isPrepaid ? '2rem' : '1rem')};
    }

    @media (max-width: 386px) {
        font-size: ${({ isPrepaid }) => (isPrepaid ? '2rem' : '1rem')};
    }
`;

export const PriceDescription = styled.p`
    margin-top: 1px;
    font-size: 0.8rem;
    text-align: center;
    /* font-weight: 600; */
    font-weight: 400;

    color: ${props => (props.isMobile ? "#BAC1CF" : "#21262F")}; 

    &:nth-child(2) {
        color: ${props => (props.isMobile ? "#21262F" : "#21262F")}; 
    }
    
    &:nth-child(3) {
        color: ${props => (props.isMobile ? "#BAC1CF" : props.isPre ? `${theme.colors.red.Vermelho_erro}` : "#21262F")};
    
        /* color: ${props => (props.isMobile ? "#BAC1CF" : "#21262F")}; */
    }

    &:nth-child(4) {
        color: ${props => (props.isMobile ? "#BAC1CF" : `${theme.colors.red.Vermelho_erro}`)};

        /* color: ${props => (props.isMobile ? `${theme.colors.red.Vermelho_erro}` : "#21262F")}; */
    }

    /* @media (max-width: 1237px) {
        font-size: 0.8rem;
    } */

    @media (max-width: 570px) {
        font-size: 0.7rem;
    }
`;

export const PriceDescriptionForAnual = styled.p`
    margin-top: 2px;
    font-size: 10px;
    text-align: center;
    font-weight: 600;

    color: ${props => (props.isMobile ? "#8A92A2" : "#BAC1CF")}; 
`;

export const PriceDescriptionPrePago = styled.p`
    margin-top: 1px;
    font-size: 0.8rem;
    text-align: center;
    /* font-weight: 600; */
    font-weight: 400;

    color: ${props => (props.isMobile ? "#BAC1CF" : "#21262F")}; 

    &:nth-child(2) {
        color: ${props => (props.isMobile ? "#BAC1CF" : "#21262F")}; 
    }
    
    &:nth-child(3) {
        color: ${props => (props.isMobile ? "#BAC1CF" : "#21262F")};
    
        /* color: ${props => (props.isMobile ? "#BAC1CF" : "#21262F")}; */
    }

    &:nth-child(4) {
        color: ${props => (props.isMobile ? "#BAC1CF" : `${theme.colors.red.Vermelho_erro}`)};

        /* color: ${props => (props.isMobile ? `${theme.colors.red.Vermelho_erro}` : "#21262F")}; */
    }

    /* @media (max-width: 1237px) {
        font-size: 0.8rem;
    } */

    @media (max-width: 570px) {
        font-size: 0.7rem;
    }
`;

export const ButtonBelowPrices = styled.div`
    display: none;

    @media (max-width: 1237px) {
        width: 100%;
        max-width: 960px;

        display: flex;
        justify-content: center;
        
        background-color: #fff;
    }
`;

export const AdditionalText = styled.p`
    margin: 0;
    padding: 0.625rem 0;
    
    color: #555;
    font-size: 13px;
    text-align: start;
    @media (max-width: 1237px) {
        display: ${({ isPrepaid }) => (isPrepaid ? 'none' : 'none')};
    }
`;

export const MobileAdditionalTextContainer = styled.div`
    display: none;

    @media (max-width: 1237px) {
        margin: 0;
        width: 100%;
        padding: 1.25rem;
        max-width: 960px;

        display: flex;
        flex-direction: column;
        
        color: #555;
        font-size: 0.9rem;
        text-align: center;
        box-sizing: border-box;
        background-color: #fff;
        justify-content: flex-start;
        border-bottom-left-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }
`;

export const MobileAdditionalText = styled.p`
    color: #555;
    text-align: left;
    font-size: 78%;
`;

export const ShowPrePaidPlanContainer = styled.div`
    width: 100%;

    >div{
        margin: 1rem 0 0;
    }
`;

export const PrePaidPlanContainer = styled.div`
    padding: 1.25rem;
    margin: 1.25rem;
    
    color: #03903E;
    font-size: 95%;
    font-weight: 600;
    text-align: center;
    border-radius: 0.5rem;
    box-sizing: border-box;
    background-color: #d4edda;
    margin-top: ${({ isPrepaid }) => (isPrepaid ? '0.5rem' : '')};

    button {
        all: unset;
        cursor: pointer;
        color: #589BFF;
    }

    @media (max-width: 1237px) {
        font-size: 80%;
        /* margin-top: ${({ isPrepaid }) => (isPrepaid ? '1.25rem' : '')}; */
    }
`;

export const MobilePlans = styled.h1`
    display: flex;
    color: white;
    font-size: 1.7rem;

    @media (max-width: 479px) {
            font-size: 1.25rem;
            line-height: 1.2em;
            font-weight: 800;
            max-width: 5.438rem;
        }
`;